import { useTranslation } from 'react-i18next'
import { Col, Row } from 'react-bootstrap'
import PropTypes from 'prop-types'
import FullLogo from '../../assets/logos/full-logo.png'
import theme from '../../constants/theme'
import {
  FooterContent,
  JobApplicationPositionCard,
  Typography,
  FullPageContainer,
  ScrollableContainer,
  StickyFooter,
  FooterText,
} from '../styled'
import AbstractForm from '../forms/AbstractForm'
import ProgressBar from '../progress-bar/progressBar'
import LanguagesDropdown from '../languageDropdwn'

function TalentPoolForm({
  talentPool,
  company,
  formInputs,
  validationSchema,
  actions,
  defaultValues,
  progressRef,
  errorRef,
}) {
  const { t } = useTranslation()

  return (
    <FullPageContainer>
      <ScrollableContainer className="mt-3 mb-3">
        <Row className="my-2 align-items-end">
          <Col sm="auto">
            <img height="auto" width="150px" src={FullLogo} alt="" />
          </Col>
          <Col />
          <Col sm="1">
            <LanguagesDropdown />
          </Col>
        </Row>
        <Row className="mt-4 pb-5 justify-content-center">
          <Col sm={12} md={8}>
            <JobApplicationPositionCard
              className="h-100 px-4 pt-3 pb-4"
              style={{
                boxShadow: '0px 15px 20px 0px rgba(18, 38, 63, 0.15)',
                overflowY: 'auto',
                maxHeight: '70vh',
              }}
            >
              <Row className="p-3 pb-0">
                <Typography size="24px" bold color={theme.talentinoBlack}>
                  {t('pages.joinTalentPool')}
                </Typography>
                <Typography
                  size="16px"
                  color={theme.talentinoBlue}
                  className="mt-1"
                >
                  {talentPool.name} - {company?.companyName}
                </Typography>
                <Typography
                  size="15px"
                  className="my-3"
                  regular
                  style={{ color: '#4B5563' }}
                >
                  {t('pages.talentPoolDescription')}
                </Typography>
              </Row>
              <Row className="m-3">
                <AbstractForm
                  inputs={formInputs}
                  schema={validationSchema}
                  actions={actions}
                  defaultValues={defaultValues}
                >
                  <ProgressBar
                    ref={{
                      progressRef,
                      errorRef,
                    }}
                  />
                </AbstractForm>
              </Row>
            </JobApplicationPositionCard>
          </Col>
        </Row>
      </ScrollableContainer>
      <StickyFooter>
        <FooterText>
          <span style={{ fontWeight: '600' }}>
            {t('footer.TalentinoAI')}{' '}
            <FooterContent>© {new Date().getFullYear()}</FooterContent>
          </span>
          .{' '}
          <span style={{ fontWeight: '600' }}>
            {t('footer.allRightsReserved')}
          </span>
        </FooterText>
      </StickyFooter>
    </FullPageContainer>
  )
}

TalentPoolForm.propTypes = {
  talentPool: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  company: PropTypes.shape({
    companyName: PropTypes.string,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formInputs: PropTypes.arrayOf(PropTypes.object).isRequired,
  validationSchema: PropTypes.shape({}).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  actions: PropTypes.arrayOf(PropTypes.object).isRequired,

  defaultValues: PropTypes.shape({}).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  progressRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errorRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
}

export default TalentPoolForm
